var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "SF 60x60@2x",
    fill: "#fff",
    stroke: "#eaeaea"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59",
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68",
    d: "M24 1v10.9a6.85 6.85 0 00-4.71-1.9 6.706 6.706 0 00-2.29.41V1.7L22.7 0a1.344 1.344 0 01.9.2.909.909 0 01.4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 69",
    d: "M15 1.7v9.83a6.488 6.488 0 00-2.42 5.18 9.209 9.209 0 001.9 4.96L9 20.3V.2z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 70",
    d: "M7 .2L.7 2A1.2 1.2 0 000 3v18a.909.909 0 00.4.8 1.421 1.421 0 00.6.2h.3L7 20.3z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 71",
    d: "M19.288 12a4.665 4.665 0 00-4.711 4.712c0 2.709 3.854 6.671 4.293 7.114a.59.59 0 00.837 0c.439-.443 4.293-4.405 4.293-7.114A4.666 4.666 0 0019.288 12z",
    fill: "#ef5323"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 13",
    cx: 1.178,
    cy: 1.178,
    r: 1.178,
    transform: "translate(18.11 15.534)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeography);
export default __webpack_public_path__ + "static/media/geography.c8d9f1141c0f0ea4adcb54d86b328d4a.svg";
export { ForwardRef as ReactComponent };